var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-sm-auto login__wrapper"},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('keep-alive',[_c(_vm.loginStepComponent,{tag:"component",attrs:{"internal":""},on:{"submit":_vm.onSubmit,"success":function($event){return _vm.$emit('success')},"error":function($event){return _vm.$emit('error')}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }